<ng-container [ngSwitch]="contentVariant" >
  <!-- external link -->
  <a *ngSwitchCase="urlType.External" class="icon-panel-item__content" [href]="data.link.value?.url" [target]="data.link.value?.target || '_self'">
    <app-picture class="icon-panel-item__image" [data]="data.icon.value" [scale]="data.iconScale.value"></app-picture>
    <div *ngIf="data.title.value" class="icon-panel-item__title">{{ data.title.value }}</div>
  </a><!-- /external link -->

  <!-- internal link -->
  <a *ngSwitchCase="urlType.Node" class="icon-panel-item__content" [routerLink]="data.link.value?.url">
    <app-picture class="icon-panel-item__image" [data]="data.icon.value" [scale]="data.iconScale.value"></app-picture>
    <div *ngIf="data.title.value" class="icon-panel-item__title">{{ data.title.value }}</div>
  </a><!-- /internal link -->

  <div *ngSwitchDefault  class="icon-panel-item__content">
    <app-picture class="icon-panel-item__image" [data]="data.icon.value" [scale]="data.iconScale.value"></app-picture>
    <div *ngIf="data.title.value" class="icon-panel-item__title">{{ data.title.value }}</div>
  </div>
</ng-container>